<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Maintenance Schedule</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <p><b>Title</b>: {{ asset_maintenance_schedule.title }}</p>
<!-- Phase 4 -->
<!--  <p><b>Schedule Mode</b>: {{ assetMaintenanceSchedulesService.getScheduleModeLabel(asset_maintenance_schedule.schedule_mode) }}</p>-->
  <p><b>Maintenance Type</b>: {{ assetMaintenanceRecordsService.getTypeLabel(asset_maintenance_schedule.maintenance_type) }} <span *ngIf="asset_maintenance_schedule.maintenance_type_other">- {{ asset_maintenance_schedule.maintenance_type_other }}</span></p>
  <p><b>Default Priority</b>: <span [style.color]="assetMaintenanceRecordsService.getPriorityColor(asset_maintenance_schedule.default_priority) || null">{{ assetMaintenanceRecordsService.getPriorityLabel(asset_maintenance_schedule.default_priority) }}</span></p>

  <ng-container *ngIf="asset_maintenance_schedule.description">
    <p><b>Description</b>: <br><span class="multiline-text">{{ asset_maintenance_schedule.description }}</span></p>
  </ng-container>

  <p class="d-flex align-items-center">
    <b>Schedule Enabled</b>:
    <span [ngClass]="{'schedule-enabled-yes': asset_maintenance_schedule.enabled, 'schedule-enabled-no': !asset_maintenance_schedule.enabled}">
      <mat-icon *ngIf="asset_maintenance_schedule.enabled" class="ml-2 mr-0 my-auto" style="font-size: 22px">power_settings_new</mat-icon>
      &nbsp;{{ asset_maintenance_schedule.enabled ? 'Yes' : 'No' }}
    </span>
  </p>

  <p class="d-flex align-items-center">
    <b>Recurring Schedule</b>:
    <span [ngClass]="{'recurring-yes': asset_maintenance_schedule.is_recurring, 'recurring-no': !asset_maintenance_schedule.is_recurring}">
      <mat-icon *ngIf="asset_maintenance_schedule.is_recurring" class="ml-2 mr-0 my-auto" style="font-size: 22px">repeat</mat-icon>
      &nbsp;{{ asset_maintenance_schedule.is_recurring ? 'Yes' : 'No' }}
    </span>
  </p>

  <p class="d-flex align-items-center">
    <b>Automatically Creates Maintenance Records</b>:
    <span [ngClass]="{'auto-create-yes': asset_maintenance_schedule.auto_create, 'auto-create-no': !asset_maintenance_schedule.auto_create}">
      <mat-icon *ngIf="asset_maintenance_schedule.auto_create" class="ml-2 mr-0 my-auto" style="font-size: 22px">note_add</mat-icon>
      &nbsp;{{ asset_maintenance_schedule.auto_create ? 'Yes' : 'No' }}
    </span>
  </p>

  <p><b>All Day Maintenance</b>: {{ asset_maintenance_schedule.is_all_day ? 'Yes' : 'No' }}</p>

  <ng-container *ngIf="!asset_maintenance_schedule.is_all_day">
    <p><b>Maintenance Expected Duration</b>: {{ durationSummary }}</p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.next_due_at">
    <p>
      <b>Next Due Date:</b> <span [style.color]="utils.getDueDateColor(asset_maintenance_schedule.next_due_at) || null">
        {{ (asset_maintenance_schedule.next_due_at * 1000) | timezoneConvertLong }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.next_auto_create_at && asset_maintenance_schedule.auto_create">
    <p>
      <b>Next Auto Create Date:</b> <span [style.color]="utils.getDueDateColor(asset_maintenance_schedule.next_auto_create_at) || null">
        {{ (asset_maintenance_schedule.next_auto_create_at * 1000) | timezoneConvertLong }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.last_triggered_at">
    <p><b>Last Triggered At:</b> {{ (asset_maintenance_schedule.last_triggered_at * 1000) | timezoneConvertLong }}</p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.schedule_start_at && isRecurringSchedule">
    <p>
      <b>Schedule Start Date:</b>
      <ng-container *ngIf="asset_maintenance_schedule.is_all_day; else specificStartTime">
        {{ (asset_maintenance_schedule.schedule_start_at * 1000) | timezoneConvertMedium }}
      </ng-container>
      <ng-template #specificStartTime>
        {{ (asset_maintenance_schedule.schedule_start_at * 1000) | timezoneConvertLong }}
      </ng-template>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.schedule_end_at && isRecurringSchedule">
    <p>
      <b>Schedule End Date:</b>
      <ng-container *ngIf="asset_maintenance_schedule.is_all_day; else specificEndTime">
        {{ (asset_maintenance_schedule.schedule_end_at * 1000) | timezoneConvertMedium }}
      </ng-container>
      <ng-template #specificEndTime>
        {{ (asset_maintenance_schedule.schedule_end_at * 1000) | timezoneConvertLong }}
      </ng-template>
    </p>
  </ng-container>

  <ng-container *ngIf="isRecurringSchedule">
    <p><b>Schedule Summary</b>: <br>{{ scheduleSummary }}</p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.notes">
    <p><b>Notes</b>: <br><span class="multiline-text">{{ asset_maintenance_schedule.notes }}</span></p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule?.contractor">
    <p>
      <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Name</b>: {{ asset_maintenance_schedule.contractor.name }}<br>
      <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Industry</b>: {{ asset_maintenance_schedule.contractor.industry }}<br>
      <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Main Contact</b>: <span *ngIf="asset_maintenance_schedule.contractor?.main_contact"><a (click)="onUserPublicView(asset_maintenance_schedule.contractor.main_contact.hash)" matTooltip="View User Public Profile">
        {{ asset_maintenance_schedule.contractor.main_contact.contact_person }}
      </a></span>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule?.vendor">
    <p>
      <b>Vendor Name</b>: {{ asset_maintenance_schedule?.vendor?.name }}<br>
      <b>Vendor Email</b>: <a *ngIf="asset_maintenance_schedule?.vendor?.email" [href]="'mailto:' + asset_maintenance_schedule?.vendor?.email" target="_blank">{{ asset_maintenance_schedule?.vendor?.email }}</a><br>
      <b>Vendor Phone Number</b>: <a *ngIf="asset_maintenance_schedule?.vendor?.phone_e164" [href]="'tel:' + asset_maintenance_schedule?.vendor?.phone_e164" target="_blank">{{ asset_maintenance_schedule?.vendor?.phone }}</a>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule?.users && asset_maintenance_schedule.users.length">
    <p class="mb-1"><b>Assignees</b>:</p>
    <ul>
      <li *ngFor="let user of asset_maintenance_schedule.users">
        <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
          {{ user.contact_person }}
        </a>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.date_created">
    <p>
      <b>Created At</b>: {{ (asset_maintenance_schedule.date_created * 1000) | timezoneConvertLong }}<br>
      <b>Created By</b>:
      <span *ngIf="asset_maintenance_schedule?.created_by_user; else createdBySystem"><a (click)="onUserPublicView(asset_maintenance_schedule.created_by_user.hash)" matTooltip="View User Public Profile">
        {{ asset_maintenance_schedule.created_by_user.contact_person }}
      </a></span>
      <ng-template #createdBySystem>
        System
      </ng-template>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_maintenance_schedule.date_modified">
    <p>
      <b>Last Updated At</b>: {{ (asset_maintenance_schedule.date_modified * 1000) | timezoneConvertLong }}<br>
      <b>Last Updated By</b>:
      <span *ngIf="asset_maintenance_schedule?.updated_by_user; else updatedBySystem"><a (click)="onUserPublicView(asset_maintenance_schedule.updated_by_user.hash)" matTooltip="View User Public Profile">
        {{ asset_maintenance_schedule.updated_by_user.contact_person }}
      </a></span>
      <ng-template #updatedBySystem>
        System
      </ng-template>
    </p>
  </ng-container>

</mat-dialog-content>
